import React from 'react';
import { FONT_FAMILY, THEME_COLORS } from '../../themes';
import { Text, StyleSheet, Image, View } from 'react-native';
import { carCategoryMapping } from '../../../common/helper';
import { images } from '../../../common/themes';
import { TooltipV3 } from '../../../common/component';

function CarCategory({ procCategory, i3Category }) {
  const procCategoryStr = 'auction' ? procCategory?.[0]?.toUpperCase() : 'AUC';
  const i3CategoryStr = carCategoryMapping[i3Category] ?? '--';

  return (
    <TooltipV3 title={`${procCategory?.toUpperCase()} -> ${i3Category}`}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Text style={styles.text}>{procCategoryStr}</Text>
        <Image source={images.tableArrow} style={{ height: 12, width: 12, display: 'inline-flex' }} />
        <Text style={[styles.text, { color: i3CategoryStr == '--' || i3CategoryStr == procCategoryStr ? 'inherit' : THEME_COLORS.purple }]}>
          {i3CategoryStr}
        </Text>
      </View>
    </TooltipV3>
  );
}

const styles = StyleSheet.create({
  text: {
    fontFamily: FONT_FAMILY.mediumV3,
    marginHorizontal: 5,
  },
});

export default CarCategory;
